<template>
<div class="progress-tracker">
  <progress-bar :progress="progress" />
  <div class="section top has-text-centered">
    <h1 class="ttitle">{{ progress * 100 }}</h1>
    <h1 class="statusTitle">% COMPLETE</h1>
    <h1 class="subtitle">
      {{progdetail}}
    </h1>
  </div>
  <div class="section row" v-for="(task, index) in tasks" :key="index">
    <div class="columns">
      <div class="column">
        <span :class="{'active': isCurrent(index)}">
          {{ task.name }}:
        </span>
      </div>
      <div class="column has-text-right">
        <span class="status" :class="{'done': task.completed}">
          {{ status(task) }}
        </span>
      </div>
    </div>
  </div>
  <div class="section bottom">
    <button class="button is-primary is-fullwidth"
            :class="{'is-loading': loading}"
            :disabled = 'disabled'
            @click="continuePressed">
      CONTINUE
    </button>
  </div>
</div>
</template>

<script>
import ProgressBar from '@/components/progress-bar'

export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    progdetail: {
      type: String,
      default: ''
    },
    formtype: {
      type: String,
      default: 'Jobseeker'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  components: { ProgressBar },
  methods: {
    status (task) {
      return task.completed ? 'Done' : 'To do'
    },
    isCurrent (index) {
      return this.current === index
    },
    continuePressed () {
      this.$emit('onContinue')
    }
  },
  computed: {
    current () {
      const active = this.tasks.reduce((c, task) => {
        return c + (task.completed ? 1 : 0)
      }, 0)

      return active
    },
    progress () {
      if (this.formtype === 'Jobseeker') {
        const count = this.tasks.length

        if (count === 0) { return 0 }

        const active = this.tasks.reduce((c, task) => {
          return c + (task.completed ? 1 : 0)
        }, 0)

        return active / count
      } else {
        return 0.5
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.active {
  font-weight: bold;
}

.status {
}

.done {
  color: $brand-primary;
}

.ttitle {
  color: $black;
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 8px;
}

.statusTitle {
  color: $black;
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 12px
}

.subtitle {
  max-width: 273px;
  color: $black;
  font-size: 12px;
  line-height: 1.5;
  margin: 0 auto;
  margin-top: 8px;
}

.progress-tracker {
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 4px;

  .section.top {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .section.row {
    border-top: 1px solid #dddddd;
    padding: 10px 12px;
  }

  .section.bottom {
    border-top: 1px solid #dddddd;
    background-color: $brand-ghost;
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/progress-tracker.vue